<template>
  <div>
    <v-layout align-center>
      <v-flex shrink>
        <div class="title">
          <span class="mr-3">Total cost</span>
          <span>$ {{ totalCost }}</span>
        </div>
      </v-flex>
      <v-spacer/>
      <v-flex shrink>
        <v-btn
          :disabled="!subId"
          class="ma-0"
          icon
          @click="add">
          <v-icon>add</v-icon>
        </v-btn>
        <v-btn
          v-if="expand === 0 && costs.length > 0"
          class="ma-0"
          icon
          @click="expand = -1">
          <v-icon>expand_less</v-icon>
        </v-btn>
        <v-btn
          v-else
          :disabled="costs.length === 0"
          class="ma-0"
          icon
          @click="expand = 0">
          <v-icon>expand_more</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-divider/>
    <v-expansion-panel
      v-if="costs.length > 0"
      :value="expand">
      <v-expansion-panel-content>
        <v-data-table
          :headers="headers"
          :items="costs"
          hide-actions>
          <template
            slot="items"
            slot-scope="props">
            <tr>
              <td>
                {{ props.item.name }}
              </td>
              <td>
                {{ props.item.purchaseOrder }}
              </td>
              <td>
                {{ props.item.value }}
              </td>
              <td>
                {{ props.item.unit }}
              </td>
              <td class="justify-end align-center layout">
                <v-btn
                  icon
                  small
                  @click="editRate(props.item)">
                  <v-icon small>remove_red_eye</v-icon>
                </v-btn>
                <v-btn
                  icon
                  small
                  @click="removeRate(props.item.id)">
                  <v-icon small>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <!-- NEW COST DIALOG -->
    <new-cost-dialog
      v-model="newCostDialog"
      :job-id="jobId"
      :sub-id="subId"
      @refresh="$emit('refresh')"/>
    <!-- EDIT COST DIALOG -->
    <edit-cost-dialog
      v-model="editCostDialog"
      :cost="copiedCost"
      @refresh="$emit('refresh')"/>
  </div>
</template>

<script>
import NewCostDialog from "./Costs/NewCostDialog";
import EditCostDialog from "./Costs/EditCostDialog";

export default {
  name: "costs",
  components: {
    EditCostDialog,
    NewCostDialog
  },
  props: {
    costs: {
      type: Array,
      default: () => []
    },
    jobId: {
      required: true,
      type: Number
    },
    subId: {
      required: true,
      type: Number
    },
    totalCost: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      editCostDialog: false,
      copiedCost: {},
      expand: -1,
      headers: [
        {
          text: "Rate name",
          value: "name",
          width: "20%"
        },
        {
          text: "PO reference",
          value: "purchaseOrder"
        },
        {
          text: "Adjusted rate",
          value: "value",
          width: "20%"
        },
        {
          text: "Adjusted unit",
          value: "unit",
          width: "20%"
        },
        {
          sortable: false,
          width: "10%"
        }
      ],
      newCostDialog: false
    };
  },
  methods: {
    add () {
      this.newCostDialog = true;
    },
    removeRate (id) {
      if (confirm("Are you sure you want to remove this cost?")) {
        this.$http.
          delete(`/api/job_costs/${id}`).
          then(() => this.$emit("refresh"));
      }
    },
    editRate (cost) {
      Object.assign(this.copiedCost, cost);
      this.editCostDialog = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Job/Costs.vue